let activeTabId: string | null = null

/** Published by AppShellEffects' layout effect on every URL change. */
export function setShellActiveTabId(tabId: string | null): void {
  activeTabId = tabId
}

/**
 * The tab the user is looking at, readable outside React.
 *
 * The editor registry needs it to tell two identical-looking unregistrations
 * apart: a card leaving a VISIBLE tab (a sub-view swap, a real unmount) versus
 * `<Activity>` tearing down a backgrounded tab's effects.
 */
export function getShellActiveTabId(): string | null {
  return activeTabId
}
